<!--
    @本部门收到列表页
-->
<template>
    <div>
        <el-table
            stripe 
            :data="tableData" 
            :height="tableMaxHeight" 
            class="table-content" 
            id="table"
            :header-cell-style="this.$globalGrayTableHeaderStyle" 
            @filter-change="filterChange"
            @sort-change="sortChange"
            border
        >
            <el-table-column label="序号" type="index" width="50" align="center" :show-overflow-tooltip='true' fixed="left"></el-table-column>
            <el-table-column label="接收状态" prop='receivingStatusName' header-align="center" align="center" min-width='80' fixed="left" 
                :show-overflow-tooltip='true'
                :filters="[{ text: '待接收', value: 'statusCondition_1' },{ text: '已接收', value: 'statusCondition_2' },{ text: '已失效', value: 'statusCondition_3' }]"
            >
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.receivingStatus)"></i>
                    <span>{{ scope.row.receivingStatusName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="文号" prop='documentNumber'  align="left" min-width='100' :show-overflow-tooltip='true' fixed="left"></el-table-column>
            <el-table-column label="文件名称" prop='documentName' align="left" min-width='150' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column label="发送部门" prop='createDeptName' min-width='150' :show-overflow-tooltip='true'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>发送部门</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="createDeptName" @keyup.enter="customFn(3)" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="customFn(1)">取消</el-button>
                                    <el-button size="mini" type="primary" @click="customFn(3)">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="发送时间" prop='releaseTime' header-align="center" align="center" min-width='160' :show-overflow-tooltip='true' :sortable="'custom'"></el-table-column>
            <el-table-column label="接收部门" prop='receivingDeptName' min-width='200'>
                <template slot="header" slot-scope="scope">
                    <div class="custom-header">
                        <span>接收部门</span>
                        <el-popover width="300" trigger="click">
                            <div class="custom-section">
                                <p>请输入</p>
                                <el-input v-model="receivingDeptName" @keyup.enter="customFn(2)" clearable></el-input>
                                <div class="custom-section--btns">
                                    <el-button size="mini" type="text" @click="customFn(1)">取消</el-button>
                                    <el-button size="mini" type="primary" @click="customFn(2)">确定</el-button>
                                </div>
                            </div>
                            <i slot="reference" class="el-icon-search"></i>
                        </el-popover>
                    </div>
                </template>
                <template slot-scope="scope">
                    <el-tooltip class="item" :open-delay="800" effect="dark" :content="scope.row.receivingDeptName" placement="top" popper-class="popper-class">
                        <p class="issus-slot">{{scope.row.receivingDeptName}}</p>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="接收时间" prop='receiveTime' header-align="center" align="center" min-width='160' :show-overflow-tooltip='true' :sortable="'custom'"></el-table-column>
            <el-table-column label="操作" header-align="left" align="left" fixed="right" min-width='100'>
                <template slot-scope="scope">
                    <el-button type="text" size="small" title="查看" @click="getDetail(scope.row)" v-if="scope.row.receivingStatus!=3&&hasBtnPermission('btn_officalDocProcess_view')">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: () => {return []}
        }
    },
    data() {
        return {
            tableMaxHeight: document.documentElement.clientHeight - 328,
            createDeptName: '',//搜索发布部门
            receivingDeptName: ''//搜索接收部门
        }
    },
    methods: {
        customFn(num) {
            if(num == 1) {
                document.getElementById("table").click();
                return;
            }
            if(num == 2) {
                document.getElementById("table").click();
                this.$emit('emitTableSearch',{
                    type: 'receiving',
                    data: this.receivingDeptName
                })
                return;
            }
            if(num == 3) {
                document.getElementById("table").click();
                this.$emit('emitTableSearch',{
                    type: 'create',
                    data: this.createDeptName
                })
                return;
            }
        },
        formatterStatusClass(historyId) {
			switch (historyId) {
				case 2: return 'icon-point icon-point-success'; break;
				case 1: return 'icon-point icon-point-verificationing'; break;
				case 3: return 'icon-point icon-point-info'; break;
				default: return ''; break;
			}
		},
        filterChange(filter) {
            this.$emit('filterEmit',filter);
        },
        sortChange(column, prop, order) {
            this.$emit('sortEmit',{column, prop, order});
        },
        getDetail(arg) {
            removeTabHandle('officialDocProcessView')
            this.$router.push({
                name: 'officialDocProcessView',
                query: {
                    id:arg.id,
                    type:2,
                    formType: '2'
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.issus-slot {
    max-height: 46px;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    // position: relative;
    overflow: hidden;
    margin-bottom: 0;
    text-align: left;
    // &:after {
    //     content: '...';
    //     display: block;
    //     width: 20px;
    //     height: 22px;
    //     background: #fff;
    //     position: absolute;
    //     bottom: 0;
    //     right: 0;
    // }
    // &:hover::after{
    //     background: red;
    // }
}
.custom-header {
    line-height: 25px;
    margin-top: 5px;
    padding-left: 0;
    i {
        margin-left: 10px;
        cursor: pointer;
        &:hover {
            opacity: .8;
        }
    }
}
.custom-section {
    padding: 20px;
    .custom-section--btns {
        text-align: right;
        margin-top: 20px;
    }
}
</style>